import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useMfaEnrollment, usePrivy } from '@privy-io/react-auth';
import Navbar, { VETS_PATHS } from '../views/Gifts/Navbar';
import { selectPrivyToken, setPrivyToken } from '../redux/slices/auth';
import { useEffect, useState } from 'react';
import { useSetReferralMutation } from '../redux/api/authorized/auth';
import { useSelector, useDispatch } from 'react-redux';
import WidthContainer from '../components/WidthContainer';
import { useSolana } from '../hooks/useSolana';
import { useGetDefaultTokensQuery } from '../redux/api/public/tokens';
import Footer from '../components/Footer';
import { openModal } from '../redux/slices/modals';
import { UNLEASH_ENABLED_BUY_VETS } from '../constants';
import { useFlag, useFlagsStatus } from '@unleash/proxy-client-react';
import { IonPage, IonContent, IonHeader, IonToolbar } from '@ionic/react';
import styled, { useTheme } from 'styled-components';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../common/responsive';
import { Capacitor } from '@capacitor/core';
import { useListPrepaidCardsQuery } from '../redux/api/authorized/zyptoPrepaidCards';

const Container = styled.div`
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  @media ${PHONE_MEDIA_QUERY} {
    min-height: calc(100vh - 76px - 56px);
    ${() =>
      Capacitor.isNativePlatform() &&
      `
        min-height: calc(100vh - 60px - 56px - env(safe-area-inset-bottom) - env(safe-area-inset-top));
      `}
  }
`;

const AppLayout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const { showMfaEnrollmentModal } = useMfaEnrollment();
  const { data: prepaidCards } = useListPrepaidCardsQuery();
  const [mfaShown, setMfaShown] = useState(() => {
    return localStorage.getItem('mfaShown') || 'false';
  });
  const { authenticated, user, ready } = usePrivy();
  const enableBuyVets = useFlag(UNLEASH_ENABLED_BUY_VETS);

  const { refetch } = useGetDefaultTokensQuery();

  let excludeFooter = false;

  useEffect(() => {
    localStorage.setItem('mfaShown', mfaShown);
  }, [mfaShown]);

  useEffect(() => {
    if (enableBuyVets) {
      refetch();
    }
  }, [enableBuyVets, refetch]);

  useEffect(() => {
    if (user) {
      if (user.mfaMethods?.length === 0 && mfaShown === 'false') {
        //showMfaEnrollmentModal();
        //setMfaShown('true');
      }
    }
  }, [user]);

  const privyToken = useSelector(selectPrivyToken);

  const { refreshTokenBalances, isRefreshing, lastRefreshTime } = useSolana();

  const [setReferral] = useSetReferralMutation();

  useEffect(() => {
    if (ready && lastRefreshTime === 0 && !isRefreshing) {
      refreshTokenBalances();
    }
  }, [lastRefreshTime, isRefreshing, ready]);

  useEffect(() => {
    localStorage.setItem('mfaShown', mfaShown);
  }, [mfaShown]);

  useEffect(() => {
    if (user && privyToken) {
      const referralCode = localStorage.getItem('rc');
      if (referralCode) {
        const referredUser = localStorage.getItem('referredUserId');
        if (referredUser !== String(user.id)) {
          const handleReferral = async () => {
            try {
              await setReferral(referralCode).unwrap();
              localStorage.setItem('referredUserId', String(user.id));
              localStorage.setItem('rc', null);
            } catch (error) {
              if (error?.status === 404) {
                // This error is returned by the API when the privy user is not created in the DB yet
                return;
              }
              // For other errors, clear the local storage to prevent infinite retries
              localStorage.setItem('referredUserId', String(user.id));
              localStorage.setItem('rc', null);
            }
          };
          handleReferral();
        } else {
          localStorage.setItem('rc', null);
        }
      }
    }
  }, [user, privyToken, setReferral]);

  useEffect(() => {
    if (user) {
      if (user.mfaMethods?.length === 0 && mfaShown === 'false') {
        //showMfaEnrollmentModal();
        //setMfaShown('true');
      }
    }
  }, [user]);

  VETS_PATHS.forEach((vetsPath) => {
    if (location.pathname.includes(vetsPath)) {
      excludeFooter = true;
    }
  });

  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  const PageContainer = isMobile ? IonPage : 'div';

  const Content = isMobile ? IonContent : 'div';

  return (
    <PageContainer className='app-layout' id='main-content'>
      {/* If you want the Navbar fixed, put it in IonHeader.
          If it's your custom component, just render it here. */}
      {isMobile ? (
        <IonHeader>
          <IonToolbar
            style={{
              '--border-color': theme.text.disabled,
              '--min-height': 'auto',
              '--background': theme.background.primary,
            }}
          >
            <Navbar />
          </IonToolbar>
        </IonHeader>
      ) : (
        <Navbar />
      )}

      <Content style={{ '--background': theme.background.primary }}>
        <WidthContainer>
          <Container>
            <Outlet />
          </Container>
          {!excludeFooter && <Footer />}
        </WidthContainer>
      </Content>
    </PageContainer>
  );
};

export default AppLayout;
